import { t } from "@lingui/macro";

export const SupportPage = () => (
  <main className="container py-24">
    <h1 className="text-4xl font-bold">{t`Support`}</h1>
  </main>
);
